import React, { useState, useEffect } from "react";
import SnackbarAlert, { useAlert } from "./scripts/SharedComponents/snackbar-alert.js";
import { auth } from "./scripts/app.js";
import { useNavigate, Outlet } from "react-router-dom";
import { messaging } from "./scripts/app.js";
import { getToken, onMessage } from "firebase/messaging";
import { updateDoc } from "firebase/firestore";
import { getTeamUserRefs } from "./scripts/user.js";
import { useAuth } from "./scripts/app.js";

const Layout = () => {
  const alert = useAlert();
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const notifyOnMessage = () => {
    updateMessagingToken();
    onMessage(messaging, payload => {
      const notification = new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: '/icons/icon-192x192.png',
        tag: payload.data.tag
      });
      notification.onclick = () => {
        navigate(payload.fcmOptions.link);
      };
    });
  };

  const updateMessagingToken = async () => {
    if (!auth.currentUser) return;

    const currentToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY });
    if (!currentToken) return requestNotificationPermission();

    const teamUserRefs = await getTeamUserRefs(auth.currentUser);
    for (const ref of teamUserRefs) await updateDoc(ref, { messagingToken: currentToken });
  };

  const requestNotificationPermission = async () => {
    if (!("Notification" in window)) {
      console.log("Notifications not supported");
      alert.show('Notifications not supported', 'warning');
    } else {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        updateMessagingToken();
      } else {
        console.log('Notification permission denied');
        alert.show('Notifications not permitted', 'warning');
      }
    }
  };

  
  useEffect(() => {
    if (loading) return;
    if (!currentUser) navigate("/login");

    setIsLoading(false);
    notifyOnMessage();
  }, [currentUser, loading]);

  if (isLoading) return null;

  return (
    <div>
      <Outlet />
      <SnackbarAlert alert={alert} />
    </div>
  );
};

export default Layout;